module.exports = __webpack_public_path__ + "img/SDG-13-EN.d89cae32.png";